<template>

  <div
      class="filter-input main w-full inline-flex items-center relative"
      :class="{ optionIsSelected: isSelectedValid() }"
  >
    <div
        class="custom-chip w-full absolute inline-flex items-center justify-center"
        v-if="isSelectedValid()"
        @click.stop="activateOption"
        ref="customChip"
    >
      <div>
        <span class="truncate" v-if="isSelectedValid()">
          {{ displaySelectedOption }}
        </span>

        <i
            class="radius-icon feather icon-chevron-down text-2xl"
            :class="{ isCloseable: isSelectedValid() && selected.length < 2, 'radius-icon-anim': dropdownOpen }"
        ></i>

      </div>
    </div>

    <vs-dropdown
        :disabled="inputDisabled"
        vs-custom-content
        vs-drop-left
        vs-trigger-click
        class="custom-select"
        :class="{ 'is-active': dropdownOpen }"
        @focus="handleChange"
        @blur="handleChange"
        ref="selectInput">

      <div class="input-select flex items-center text-onyx" :class="{ 'dropdown-disabled': inputDisabled }">
        {{ placeholder }}
        <vs-icon class="" icon-pack="feather" icon="icon-chevron-down"></vs-icon>
      </div>

      <vs-dropdown-menu class="custom-select--menu">
        <ul>
          <li v-for="(item, index) in selectOptions" :key="index" class="select-item flex items-center justify-between">
            <vs-radio
                color="primary"
                v-model="selected"
                :vs-value="(item.id || item.option).toString()"
                v-if="isRadioOption"
                @input="selectOption">
              {{ item.option }}
            </vs-radio>
          </li>
        </ul>
      </vs-dropdown-menu>

    </vs-dropdown>
  </div>

</template>

<script>
export default {
  props: {
    inputDisabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      required: true,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectOptions: this.options.value,
      radioModel: '',
      dropdownOpen: false,
      checkBoxInterval: null
    };
  },
  computed: {
    /**
     * @return {function(*=)}
     */
    isSelectedValid() {
      return ( val = 0 ) => {
        return (this.selected && (this.selected.length > val));
      }
    },
    selected : {
      get(){
        return this.options.selected;
      },
      set( value ) {
        this.setSelectedValue(value);
      }
    },
    displaySelectedOption() {
      let selectedOption = this.selectOptions.filter( option => {
        if(Array.isArray(this.selected)) {
          return (option.id ||  option.option) == this.selected[0];
        }
        return (option.id ||  option.option) == this.selected;
      })[0];
      const label = selectedOption ? selectedOption.hasOwnProperty('display') ? selectedOption.display : selectedOption.option : '';
      if (this.isSelectedValid(1)) {
        return `${label.substring(0, 15)}...`;
      }
      return label;
    },
    isRadioOption() {
      return this.options.type === 'radio'
    },
    selectAll: {
      get: function () {
        return (this.selectOptions && (this.selectOptions.length > 1)) ?
            (this.selected && (this.selected.length === this.selectOptions.length - 1)) :
            false;
      },
      set: function (value) {
        if (!this.selectAll) {
          this.selectAllOptions();
        } else {
          this.selected = [];
        }
      }
    }
  },
  methods: {
    setSelectedValue(value) {
      this.$emit("selectedOption", this.options.name, value);
    },
    activateOption() {
      this.$refs.selectInput.$el.click();
    },
    selectOption(){
      this.activateOption();
      this.submitSearch( 200 );
    },
    submitMultipleSearch(time) {
      if (this.checkBoxInterval) clearInterval(this.checkBoxInterval);
      this.checkBoxInterval = setInterval(() => {
        clearInterval(this.checkBoxInterval);
        this.$emit('submitFilters');
      }, time);
    },
    submitSearch( time ){
      setTimeout( () =>{
        this.$emit('submitFilters');
      }, time);
    },
    clearChip() {
      this.selected = [];
      if (this.isRadioOption) {
        this.radioModel = '';
      }
      this.submitSearch( 200 );
    },
    isAllSelector(option) {
      return (option == "0");
    },
    handleChange(e) {
      this.dropdownOpen = this.$refs.selectInput.vsDropdownVisible;
    },
    selectAllOptions() {
      let selected = [];
      this.selectOptions.forEach(opt => {
        if (!this.isAllSelector(opt.id || opt.option)) {
          selected.push(opt.id.toString() || opt.option);
        }
      });
      this.selected = [...selected];
    },
  },
  created() {
    if (this.isRadioOption) {
      this.radioModel = this.options.initValue || '';
    }else {
      if (this.options.initValue == "0") {
        this.selectAllOptions();
      }
      else {
        this.selected = [...(this.options.initValue  || [])]
      }
    }
  },
  watch: {
    selected(val) {
      this.$emit('input', val);
    },
    radioModel(val) {
      if (val !== '') {
        this.selected = [val];
      }
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss">
.filter-input {
  .dropdown-disabled {
    color: rgb(var(--colors-gray-300)) !important;
  }
  .optionIsSelected {
    width: 156px;
    margin-right: 0px;
  }
  .main {
    min-width: auto;
    background-color: var(--select-input) !important;
    border-radius: 6px;
  }
  .custom-chip {
    border-radius: 6px;
    width: 156px;
    height: 40px;
    font-size: 14px;
    background-color: var(--select-input) !important;
    z-index: 50;
    padding-left: 12px;
    padding-right: 6px;
    margin-right: 6px;
    & .icon-x.isCloseable {
      display: inline-flex !important;
      font-size: 15px;
    }
    &:hover {
      cursor: pointer;
      & .icon-x {
        display: inline-flex !important;
        font-size: 15px;
        z-index: 1000;
      }
      & .count-badge {
        display: none;
      }
    }
    & > div {
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      & > span.count-badge {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        background: var(--primary-darker) !important;
        font-size: 12px;
        color: rgb(var(--colors-white));
        border-radius: 50%;
        text-align: center;
        position: absolute;
        right: 5px;
      }
    }
  }
  .con-slot-label {
    margin-left: 3px;
    color: var(--onyx-light);
    font-size: 14px;
    font-family: Montserrat;
    margin-top: 5px;
  }
  .vs-radio--label {
    font-size: 14px;
    color: var(--onyx-lightest);
    margin-left: 8px !important;
  }
  .selected {
    background-color: transparent;
    width: 100%;
    border-radius: 6px;
    height: 100%;
    outline: none;
    font-family: Montserrat;
    font-size: 14px;
    appearance: none;
    padding: 0 12px;
    display: flex;
    align-items: center;
    -webkit-appearance: none;
  }
  .items {
    color: rgb(var(--colors-gray-600));
    border-radius: 6px;
    overflow: hidden;
    position: absolute;
    background-color: var(--white);
    left: 0;
    right: 0;
    top: 4rem;
  }
  .item {
    color: rgb(var(--colors-gray-600));
    padding-left: 8px;
    cursor: pointer;
    user-select: none;
  }
  .selectHide {
    display: none;
  }
  .select-options {
    text-align: left;
  }
  .radius-icon {
    transition: all 250ms ease-in-out;
    &.radius-icon-anim {
      transform: rotate(-180deg);
    }
  }
  .custom-select {
    cursor: pointer;
    margin-right: 16px;
    min-width: auto;
    width: 100%;
    min-height: 40px;
    padding: 10px 0 10px 10px;
    &.is-active {
      .input-select {
        i {
          transform: translateY(-50%) rotate(-180deg);
        }
      }
    }
    .input-select {
      border: none;
      font-family: Montserrat;
      position: relative;
      i {
        position: absolute;
        font-size: 1.0625em;
        top: 50%;
        pointer-events: none;
        transform: translateY(-50%);
        transition: all .2s ease;
        right: 0;
      }
    }
  }
  .custom-select--menu {
    z-index: 9999999;
    .select-item {
      height: 42px;
      padding: 0 22px !important;
      min-width: 305px;
      > * {
        width: 100%;
        cursor: pointer;
        margin: 0;
      }
    }
    .vs-dropdown--menu {
      padding: 8px 0 !important;
      max-height: 260px;
      overflow-y: auto;
      border-radius: 4px;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        display: block;
      }
      &::-webkit-scrollbar-thumb {
        background: var(--lunar);
        border-radius: 5px;
      }
    }
    .vs-dropdown-right--menu--after {
      display: none;
    }
  }
}
</style>